<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
    console.log(data)

    this.state.chart.setOption({
      title: {
        show:true,
        text:'近五年企业研发投入情况',
        left:'center',
        top:'3%',
        textStyle:{
          color:"rgba(1,189,222,.8)",
          fontSize:28,
          fontWeight:'normal'
        }
      },
      grid: {
        top: '20%',
        left: '15%',
        right: '5%',
        bottom: '15%',
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLine: {
            show: true,
            onZero:false,
            lineStyle: {
              color: "#024349"
            }
        },
        axisLabel: {
            show: true,
            textStyle: {
              color:  'rgba(255,255,255,.65)', 
              fontSize: 26,
            }
        },
        data: data[0]
      },
    yAxis: {
      type: 'value',
      name:"单位（万）",
      nameTextStyle: {
        align: 'left', // 对齐方式
        verticalAlign: 'top' ,// 垂直对齐方式
        color:"rgba(255,255,255,.8)",
        fontSize: 24,
      },
      axisLabel:{
         show:true,
         textStyle: {
            color:  'rgba(255,255,255,.65)', 
            fontSize: 24,
          }
      },      
      splitLine: {
        show:true,
        lineStyle:{
          color:"#35414D",
          type: [5, 10],
          dashOffset: 5
        }
      }
    },
    series: [
      {
        data: data[1],
        type: 'line',
        smooth: true,  
        symbolSize: 0.01,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
            {
              offset: 0,
              color:'rgba(235, 113 ,21,0)'
            },
            {
              offset: 1,
              color:'rgba(235, 113 ,21,0)'
            },
            {
              offset: 0,
              color:'rgba(235, 113 ,21,.2)'
            },
          ])
        },
        itemStyle: {
          color:'#E3BD5A'
        },
        lineStyle: {
          // 线条加阴影
          // 设置阴影颜色
          // shadowColor: "#3D5DF4",
          shadowColor:"#E3BD5A",
          shadowOffsetX: 0,
          // 设置阴影沿y轴偏移量为9
          shadowOffsetY: 9,
          // 设置阴影的模糊大小
          shadowBlur: 20,
          // 设置线条渐变色
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: "#EB7115" },
            // { offset: 0.2, color: "#3D5DF4" },
            { offset: 0.2, color: "#EB7115" },
            { offset: 0.1, color: "#EB7115" },
          ]),
        },

        emphasis: {
        scale: 1000,
        itemStyle: {
          color: "#3D5DF4",
          borderColor: "#FFFFFF",
          borderWidth: 3,
          borderType: "solid",
        },
      },

      }
    ]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
